export const truthy: (v: any) => boolean = (v) => {
  if (typeof v === 'string') {
    return v.toLowerCase() === "true"
  }
  if (typeof v === 'boolean') {
    return v
  }
  return false
}